import styled from "styled-components";

export const ModalContainer = styled.div`
  width: 100%;
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  bottom: 0;
  direction: rtl;
`;

export const ModalWrapper = styled.div`
  background-color: aqua;
  width: 528px;
  height: auto;
  position: absolute;
  top: 50%;
  left: 50%;
  padding: 24px 24px;
  background: var(--bg-white);
  border-radius: 12px;
  box-shadow: 2px 4px 10px rgba(108, 136, 170, 0.25);
  transform: translate(-50%, -50%);
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
`;

export const ImgContainer = styled.div`
  width: 245px;
  height: 140px;
  margin-bottom: 24px;
  & img {
    width: 100%;
    height: auto;
    display: block;
  }
`;
export const TransactionMassage = styled.div`
  margin-bottom: 24px;
  & h2 {
    font-weight: 500;
    font-size: 16px;
    color: var(--text-500);
  }
`;
export const InfoContainer = styled.section`
  width: 100%;
  & .date {
    display: flex;
    flex-direction: row-reverse;
    & > p:nth-of-type(1) {
      margin-right: 10px;
    }
  }

  & > div {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 10px 0;
    color: var(--text-400);
    font-size: 14px;
    font-weight: 500;
    border-bottom: 1px solid var(--bg-gray);
    &:first-child {
      padding-top: 0;
    }
    &:last-child {
      padding-bottom: 0;
      border: none;
    }
    & > div:last-child {
      font-weight: 400;
    }
  }
`;

export const Button = styled.div`
  border: none;
  outline: none;
  width: 140px;
  height: 40px;
  margin-top: 48px;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-500);
  border-radius: 8px;
  color: var(--bg-white);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
`;
